import React from "react";
import { Box, type SpaceProps, VisuallyHidden, type LayoutProps } from "@chakra-ui/react";
import { VideoJsonLd } from "next-seo";

type HeroVideoProps = {
  /** URL to an MP4 format of the video. */
  sourceMp4: string;
  /** Optional URL to a WebM format of the video. */
  sourceWebm?: string;
  /** Title used for SEO. */
  title: string;
  /** Description used for SEO. */
  description: string;
  /** Thumbnail URL used for SEO. */
  poster: string;
  /** Date used for SEO. */
  uploadDate: string;
  /** Description of the video visuals for a11y. */
  alt?: string;
  /** Used to set the appropriate codec. */
  isTransparent?: boolean;
} & SpaceProps &
  LayoutProps;

export function HeroVideo({
  sourceMp4,
  sourceWebm,
  title,
  description,
  poster,
  uploadDate,
  isTransparent,
  alt,
  ...props
}: HeroVideoProps) {
  const describedById = "hero-video-alt";
  return (
    <>
      <Box pos="relative" borderRadius="md" overflow="hidden" maxW={{ base: "2xl", xl: "100%" }} mx="auto" {...props}>
        <video playsInline muted loop autoPlay width="100%" preload="metadata" aria-describedby={describedById}>
          <source src={sourceMp4} type={`video/mp4${isTransparent ? ";codecs=hvc1" : ""}`} />
          {sourceWebm && <source src={sourceWebm} type="video/webm" />}
        </video>
      </Box>

      <VisuallyHidden id={describedById}>{alt}</VisuallyHidden>

      <VideoJsonLd
        name={title}
        description={description}
        contentUrl={sourceMp4}
        embedUrl={sourceMp4}
        thumbnailUrls={[poster]}
        uploadDate={uploadDate ?? "2023-08-01T08:00:00+08:00"}
      />
    </>
  );
}
